module.exports = __webpack_public_path__ + "img/open_in_new.bf459209.svg";